import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WindowService } from 'app/_service/screen-size.service';
import { TvLiveService } from './tv-live.service';

@Component({
  selector: 'app-tv-live',
  templateUrl: './tv-live.component.html',
  styleUrls: ['./tv-live.component.scss']
})
export class TvLiveComponent implements OnInit {
  @Input() liveList = [];
  tvList = [];
  noDataHide = false;
  currentIndex = 0;
  newColumn = 8;
  @ViewChild('track') track: ElementRef;

  constructor(
    private _windowService: WindowService,
    private _cd: ChangeDetectorRef,
    private _tvLiveService: TvLiveService,
  ) { }

  ngOnInit(): void {
    // this.getTvList();
    this._windowService.size$.subscribe((value: any) => {
      this.detectChange(value);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['liveList'].currentValue) {
      this.tvList = this.liveList;
      this.noDataHide = !(this.liveList.length > 0); // 加载时正常显示占位图，未获取到任何数据，再隐藏
    }
  }

  private detectChange(value) {
    const previous = this.newColumn;
    let current = value === 5 ? 8 : value === 4 ? 7 : 6;
    this.newColumn = current;
    if (previous !== current) {
      this.moveTrack();
      this._cd.detectChanges();
    }
  }

  getTvList() {
    this._tvLiveService.getTvLiveList().subscribe(res => {
      // console.log(res);
      if (!!res && res.code !== 401) {
        this.tvList = res;
      }
      this.noDataHide = !(res.length > 0); // 加载时正常显示占位图，未获取到任何数据，再隐藏
    })
  }

  navLast() {
    this.currentIndex -= this.newColumn; // 一次滑动的数量根据尺寸来定
    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }
    // console.log(this.currentIndex);
    this.moveTrack(true);
  }

  navNext() {
    this.currentIndex += this.newColumn; // 一次滑动的数量根据尺寸来定
    // console.log(this.currentIndex);
    this.moveTrack(true);
  }

  moveTrack(useAnimation = false) {
    const trackElement = this.track?.nativeElement;
    // console.log(trackElement);
    if (!!trackElement) {
      let box = trackElement.getElementsByClassName("tv-box").item(0);
      if (box === null) {
        return;
      }
      if (useAnimation) {
        trackElement.classList.add('animation');
      } else {
        trackElement.classList.remove('animation');
      }
      const properIndex = (this.tvList.length - this.newColumn);
      if (this.currentIndex >= properIndex) {
        this.currentIndex = properIndex > 0 ? properIndex : 0;
      }
      const trackItemWitdh = box.clientWidth;
      trackElement.style.transform = `translate3d(${ (trackItemWitdh + 5) * -(this.currentIndex) }px, 0px, 0px)`;
    }
  }

}
